import styled from "@emotion/styled";
import { MAIN_COLOR } from "../../utils/constants/common/utils";

const XDiv = styled.div`
  &.XElement-Selected {
    outline: 2px solid ${MAIN_COLOR};
    outline-offset: 2px;
  }

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export default XDiv;
